export default "__VITE_ASSET__CmoR188G__"